//
// # Schema enum narrowers
//
// Shared runtime validators + narrowers for the schema enum fields (PortDir /
// PinType). The typia validators are the single source of truth for the valid
// literals, so neither callers reading live entity values nor callers handling
// `<select>` input need to hand-enumerate the cases.
//
// - `read*` narrow an `unknown` to the enum, returning `undefined` on a
//   mismatch (for reading defensively off a live entity).
// - `to*` narrow a `<select>` string to the enum with a safe default (the
//   control only ever yields a rendered option value, so the default is a
//   belt-and-braces fallback rather than a real code path).
//

import typia from "typia";
import { validate as v } from "CoreUtils";
import type { schema } from "GenAlphaSchema";

const PortDirValidator = new v.Validator(
  typia.createValidate<schema.core.PortDir>()
);
const PinTypeValidator = new v.Validator(
  typia.createValidate<schema.core.PinType>()
);

export function readPortDir(value: unknown): schema.core.PortDir | undefined {
  const r = PortDirValidator.validate(value);
  return r.err ? undefined : r.val;
}

export function readPinType(value: unknown): schema.core.PinType | undefined {
  const r = PinTypeValidator.validate(value);
  return r.err ? undefined : r.val;
}

export function toPortDir(value: string): schema.core.PortDir {
  return readPortDir(value) ?? "input";
}

export function toPinType(value: string): schema.core.PinType {
  return readPinType(value) ?? "signal";
}
